import { Button, Form } from 'antd'
import React, { useState, useEffect } from 'react'

import Editor from 'ckeditor5-custom-build/build/ckeditor'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import InfoField from '~/components/infoField'
import PropTypes, { bool, func, object, shape, string } from 'prop-types'
import VirtualAssistant from '../../virtualAssistent'
import {
	ckeditorCss,
	resizableCkeditorStylesForDocumentDetail,
} from '../../../utils/ckeditorStylingDeffaults'
// import api from '~/services/api'
// import { errorMessage } from '~/services/messager'
// import { useSelector, useDispatch } from 'react-redux'
// import { uploadThreadId_DocumentForm } from '~/states/modules/contextAi'

const CkeditorCustomFormInput = ({ value, onChange }) => {
	//controls the Ai Assistant display
	const [openVirtualAssistant, setOpenDrawer] = useState(false)

	// stores the ckeditor editor component so that we can set the content from the parent component
	const [editor, setEditor] = useState(null)

	// const { Context } = useSelector(({ contextAi }) => contextAi)
	// const [isLoadingApiData, setIsLoadingApiData] = useState(false)
	// const [promptResponse, setPromptResponse] = useState('')
	// const dispatch = useDispatch()

	const addTextToEditor = (text) => {
		editor.model.change((writer) => {
			writer.insertText(
				text,
				editor.model.document.selection.getFirstPosition()
			)
		})
	}

	const executeAI = () => {
		// if (prompt !== '' && promptResponse === '') {
		// 	const payload = {
		// 		messages: [{ role: 'user', content: prompt }],
		// 		context_file_name: `${Context}`,
		// 	}
		// 	setIsLoadingApiData(true)
		// 	api
		// 		.post('/ai/', payload)
		// 		.then((response) => {
		// 			setPromptResponse(response.data.answer)
		// 			const newKey = `${Context}`
		// 			dispatch(
		// 				uploadThreadId_DocumentForm({ [newKey]: response.data.thread_id })
		// 			)
		// 			setIsLoadingApiData(false)
		// 		})
		// 		.catch((error) => {
		// 			setIsLoadingApiData(false)
		// 			errorMessage({
		// 				content:
		// 					'Houve um erro na comunicação com o CHatGPT. \n Por favor, tente novamente mais tarde.',
		// 			})
		// 		})
		// }
		setOpenDrawer(true)
	}

	useEffect(() => {
		const composedCss = ckeditorCss + resizableCkeditorStylesForDocumentDetail

		const style = document.createElement('style')
		style.appendChild(document.createTextNode(composedCss))

		document.head.appendChild(style)

		// Clean-up function
		return () => {
			document.head.removeChild(style)
		}
	})

	return (
		<>
			<VirtualAssistant
				open={openVirtualAssistant}
				onClose={() => setOpenDrawer(false)}
				exportText={addTextToEditor}
				doc_type={'documentForm'}
			/>
			<div
				style={{
					overflowY: 'scroll',
					height: '300px',
					width: '100%',
				}}>
				<CKEditor
					onReady={(editor) => {
						setEditor(editor)
					}}
					editor={Editor}
					config={{
						toolbar: ['bold', 'italic', 'underline'],
					}}
					onChange={(event, editor) => {
						onChange(editor.getData())
					}}
					data={value}
				/>
			</div>
			<Button
				style={{ width: '100%', marginTop: '10px' }}
				onClick={() => executeAI()}>
				Assistente virtual
			</Button>
		</>
	)
}

CkeditorCustomFormInput.propTypes = {
	value: string,
	onChange: func,
}

const ParagraphCkeditorField = ({
	pageFieldsData,
	className,
	disabled,
	visible,
	inputValue,
}) => {
	const { label, variable, info, list } = pageFieldsData

	const name = list !== undefined ? [list, variable.name] : variable.name

	const type = 'text_area_ckeditor'

	return (
		<>
			<Form.Item
				label={<InfoField label={label} info={info} />}
				key={name}
				name={name}
				type={type}
				className={className}
				hasFeedback
				colon={false}
				initialValue={inputValue}>
				<CkeditorCustomFormInput />
			</Form.Item>
		</>
	)
}

ParagraphCkeditorField.propTypes = {
	pageFieldsData: shape({
		label: string.isRequired,
		variable: PropTypes.oneOfType([object, string]),
		type: string.isRequired,
		info: string,
	}).isRequired,
	inputValue: string,
	className: string,
	onChange: func,
	first: bool,
	disabled: bool,
	visible: bool,
	typeOfText: string,
	OutsideLabel: string,
	form: object,
}

export default ParagraphCkeditorField
